export default __webpack_public_path__ + "static/media/head02_ko_pc@2x.7a4f2764.png";